import { useScriptStore } from '@/shared/store/script.store.ts'
import { patchSession } from '@/features/session/domain/use-cases/patch-session.ts'

export const deleteScript = (id: string): void => {
  const { deleteScript } = useScriptStore.getState()
  deleteScript(id)
  void patchSession()
}
